import {
    ProjectsState,
    ProjectActionType,
    ProjectsPayload,
    AuditPayload,
    AllowedTypes,
    ProjectPayload,
    CertificationsPayload,
    ApsPayload,
    CertificationPayload,
    AuditsPayload, CertificationDocumentsLinkPayload, IssuesForReviewPayload, ScoringReportPayload
} from './commonTypes';
import {ReduxAction} from '..';
import {Reducer} from 'redux';
import {IncidentsPayload} from "../incidents";

const initialState: ProjectsState = {
    projects: [],
    aps: [],
    isLoading: false,
    project: null,
    certifications: [],
    certificationId: undefined,
    certification: undefined,
    isCertificationsLoading: false,
    projectSaved: false,
    audits: [],
    audit: null,
    issues: [],
    scoringReport: null,
    isScoringReportLoading: false,
    isAuditsLoading: false,
    isIssuesLoading: false,
    reportUploaded: false,
    documentsLinkLoading: false
};

export const reducer: Reducer<ProjectsState> = (state: ProjectsState = initialState, action: ReduxAction<AllowedTypes>): ProjectsState => {
    switch (action.type) {
        case ProjectActionType.RESET_TEMP_SATE:
            return {
                ...state,
                projectSaved: false,
                reportUploaded: false
            };
        case ProjectActionType.RECEIVE_APS_LIST:
            const {aps} = action.payload as ApsPayload;
            return {
                ...state,
                aps: aps
            };
        case ProjectActionType.REQUEST_PROJECT_LIST:
            return {
                ...state,
                isLoading: true,
                project: null,
                certifications: []
            };
        case ProjectActionType.RECEIVE_PROJECT_LIST:
            const {projects} = action.payload as ProjectsPayload;
            return {
                ...state,
                projects,
                isLoading: false
            };
        case ProjectActionType.REQUEST_PROJECT_ITEM:
            return {
                ...state,
                project: null,
                isLoading: true
            };
        case ProjectActionType.RECEIVE_PROJECT_ITEM:
            const {project} = action.payload as ProjectPayload;
            return {
                ...state,
                project,
                isLoading: false
            };
        case ProjectActionType.REQUEST_PROJECT_ITEM_ERROR:
            return {
                ...state,
                project: null,
                isLoading: false
            };
        case ProjectActionType.REQUEST_PROJECT_LIST_ERROR:
            return {
                ...state,
                projects: [],
                isLoading: false
            };
        case ProjectActionType.REQUEST_CERTIFICATIONS_LIST:
            return {
                ...state,
                isCertificationsLoading: true,
                certifications: []
            };
        case ProjectActionType.RECEIVE_CERTIFICATIONS_LIST:
            const {certifications} = action.payload as CertificationsPayload;
            return {
                ...state,
                certifications,
                isCertificationsLoading: false
            };
        case ProjectActionType.REQUEST_CERTIFICATIONS_LIST_ERROR:
            return {
                ...state,
                certifications: [],
                isCertificationsLoading: false
            };
        case ProjectActionType.ADD_PROJECT_ITEM:
            return {
                ...state,
                projectSaved: false,
                isLoading: true
            };
        case ProjectActionType.ADD_PROJECT_ITEM_SUCCESS:
            return {
                ...state,
                projectSaved: true,
                isLoading: false
            };
        case ProjectActionType.ADD_PROJECT_ITEM_ERROR:
            return {
                ...state,
                isLoading: false
            };
        case ProjectActionType.REQUEST_CERTIFICATION_ITEM:
            return {
                ...state,
                certification: undefined,
                isLoading: true
            };
        case ProjectActionType.RECEIVE_CERTIFICATION_ITEM:
            const {certification} = action.payload as CertificationPayload;
            return {
                ...state,
                certification,
                isLoading: false
            };
        case ProjectActionType.REQUEST_CERTIFICATION_ITEM_ERROR:
            return {
                ...state,
                certification: undefined,
                isLoading: false
            };
        case ProjectActionType.REQUEST_CERTIFICATION_DOCUMENTS_LINK:
            return {
                ...state,
                documentsLinkLoading: true,
                documentsLink: undefined,
                documentsLinkExpiration: undefined
            };
        case ProjectActionType.RECEIVE_CERTIFICATION_DOCUMENTS_LINK:
            const {documentsLink, expirationDate} = action.payload as CertificationDocumentsLinkPayload;
            return {
                ...state,
                documentsLinkLoading: false,
                documentsLink: documentsLink,
                documentsLinkExpiration: expirationDate
            };
        case ProjectActionType.REQUEST_CERTIFICATION_DOCUMENTS_LINK_ERROR:
            return {
                ...state,
                documentsLinkLoading: false,
                documentsLink: undefined,
                documentsLinkExpiration: undefined
            };
        case ProjectActionType.REQUEST_AUDITS_LIST:
            return {
                ...state,
                isAuditsLoading: true,
                audits: []
            };
        case ProjectActionType.RECEIVE_AUDITS_LIST:
            const {audits} = action.payload as AuditsPayload;
            return {
                ...state,
                audits,
                isAuditsLoading: false
            };
        case ProjectActionType.REQUEST_AUDITS_LIST_ERROR:
            return {
                ...state,
                audits: [],
                isAuditsLoading: false
            };
        case ProjectActionType.REQUEST_ISSUES_FOR_REVIEW_LIST:
            return {
                ...state,
                isIssuesLoading: true,
                issues: []
            };
        case ProjectActionType.RECEIVE_ISSUES_FOR_REVIEW_LIST:
            const {issues} = action.payload as IssuesForReviewPayload;
            return {
                ...state,
                issues,
                isIssuesLoading: false
            };
        case ProjectActionType.REQUEST_ISSUES_FOR_REVIEW_LIST_ERROR:
            return {
                ...state,
                issues: [],
                isIssuesLoading: false
            };


        case ProjectActionType.REQUEST_SCORING_REPORT_INFO:
            return {
                ...state,
                isScoringReportLoading: true,
                issues: []
            };
        case ProjectActionType.RECEIVE_SCORING_REPORT_INFO:
            const {scoringReport} = action.payload as ScoringReportPayload;
            return {
                ...state,
                scoringReport,
                isScoringReportLoading: false
            };
        case ProjectActionType.REQUEST_SCORING_REPORT_INFO_ERROR:
            return {
                ...state,
                scoringReport: null,
                isScoringReportLoading: false
            };
            
            
        case ProjectActionType.UPLOAD_REPORT_ITEM:
            return {
                ...state,
                reportUploaded: false,
                reportUploadError: '',
                isLoading: true
            };
        case ProjectActionType.UPLOAD_REPORT_ITEM_SUCCESS:
            const {certificationId} = action.payload as CertificationPayload;
            return {
                ...state,
                reportUploaded: true,
                certificationId: certificationId,
                reportUploadError: '',
                isLoading: false
            };
        case ProjectActionType.UPLOAD_REPORT_ITEM_ERROR:
            const {reportUploadError} = action.payload as CertificationPayload;
            return {
                ...state,
                reportUploadError: reportUploadError,
                isLoading: false
            };
        case ProjectActionType.REQUEST_AUDIT_ITEM:
            return {
                ...state,
                audit: null,
                isLoading: true
            };
        case ProjectActionType.RECEIVE_AUDIT_ITEM:
            const {audit} = action.payload as AuditPayload;
            return {
                ...state,
                audit,
                isLoading: false
            };
        case ProjectActionType.REQUEST_AUDIT_ITEM_ERROR:
            return {
                ...state,
                audit: null,
                isLoading: false
            };
        default:
            return state;
    }
};
